<template>
  <div class="internal-payment-listing">
    <v-layout class="my-2">
      <v-flex md4>
        <v-text-field
          v-model.trim="search"
          v-on:click:clear="clearFilter('search')"
          clearable
          dense
          filled
          flat
          label="Search"
          hide-details
          solo
          :loading="paymentLoading"
          :disabled="paymentLoading"
          color="cyan"
          @keydown.enter="getPayments()"
          @keydown.tab="getPayments()"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-tooltip top content-class="custom-top-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              tile
              depressed
              :disabled="paymentLoading"
              v-on:click="getPayments()"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Search</span>
        </v-tooltip>
        <v-tooltip top content-class="custom-top-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              v-bind="attrs"
              v-on="on"
              class="ml-2 custom-bold-button white--text"
              color="cyan"
              tile
              :disabled="paymentLoading"
              v-on:click="getPayments()"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Reload</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <ListingTable :columnCount="9" :rowData="rowData">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">Payment #</th>
            <th class="simple-table-th">Date</th>
            <th class="simple-table-th">Customer</th>
            <th class="simple-table-th">Customer Info</th>
            <th class="simple-table-th">Invoice</th>
            <th class="simple-table-th">Payment Mode</th>
            <th class="simple-table-th">Amount</th>
            <th class="simple-table-th">Created Time</th>
            <th class="simple-table-th"
            v-if="isAdmin">Action</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="rowData.length">
            <tr
              v-for="(row, index) in rowData"
              :key="index"
              v-on:click="routeToInvoice(row)"
              :class="{ 'orange lighten-5': index % 2 }"
            >
              <td class="simple-table-td">
                <Barcode :barcode="row.barcode"></Barcode>
                <!-- <div class="mt-1">
                  <template v-if="row.status == 3">
                    <v-chip color="orange" text-color="white" small label>
                      PARTIALLY PAID
                    </v-chip>
                  </template>
                  <template v-if="row.status == 4">
                    <v-chip color="green" text-color="white" small label>
                      FULLY PAID
                    </v-chip>
                  </template>
                </div> -->
              </td>
              <td class="simple-table-td">
                <p class="m-0 custom-nowrap-ellipsis" v-if="row.payment_date">
                  <b>Payment: </b>{{ formatDate(row.payment_date) }}
                </p>
                <p class="m-0 custom-nowrap-ellipsis" v-if="row.due_date">
                  <b>Invoice Due: </b>{{ formatDate(row.invoice.due_date) }}
                </p>
                <p class="m-0 custom-nowrap-ellipsis" v-if="row.sent_date">
                  <b>Invoice Sent: </b>{{ formatDate(row.invoice.sent_date) }}
                </p>
              </td>
              <td class="simple-table-td">
                <div class="payment-listing-customer">
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Name: </b>{{ row.billing_contact_person.display_name }}
                  </p>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b><v-icon color="#000" small>mdi-domain</v-icon>: </b>
                    {{ row.customer.display_name }}
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="payment-listing-customer">
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b><v-icon color="#000" small>mdi-email</v-icon>: </b>
                    <template v-if="row?.billing_contact_person?.primary_email">
                      {{ row.billing_contact_person.primary_email }}
                    </template>
                    <template v-else>
                      <em class="text-muted"> no email</em>
                    </template>
                  </p>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b><v-icon color="#000" small>mdi-phone</v-icon>: </b>
                    <template v-if="row?.billing_contact_person?.primary_phone">
                      {{ row.billing_contact_person.primary_phone }}
                    </template>
                    <template v-else>
                      <em class="text-muted"> no phone number</em>
                    </template>
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="payment-listing-invoice" v-on:click.prevent>
                  <p class="m-0 custom-nowrap-ellipsis">
                    <Barcode
                      route="invoice.detail"
                      :id="row.invoice.id"
                      :barcode="row.invoice.barcode"
                    ></Barcode>
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="payment-listing-mode">
                  <p class="m-0 custom-nowrap-ellipsis">
                    {{ row.payment_mode && row.payment_mode.text }}
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <div class="payment-listing-amount">
                  <p class="m-0 custom-nowrap-ellipsis">
                    <b>Received: </b>
                    {{ $accountingJS.formatMoney(row.amount) }}
                    <!-- <em class="text--secondary d-block" v-if="row.status == 3">( Partially Paid )</em>
                    <em class="text--secondary d-block" v-else-if="row.status == 4">( Paid )</em>
                    <em class="text--secondary d-block" v-else>( Unpaid )</em> -->
                  </p>
                </div>
              </td>
              <td class="simple-table-td">
                <TableActivity v-if="!lodash.isEmpty(row.added_by)" :data="row">
                  <template v-slot:display_name>
                    {{ row.added_by.display_name }}
                  </template>
                  <template v-slot:date_time>
                    {{ row.created_at }}
                  </template>
                  <template v-slot:format_date_time>
                    {{ formatDateTime(row.added_at) }}
                  </template>
                </TableActivity>
              </td>
              <td class="simple-table-td" 
              v-on:click.stop 

              >
                <v-btn icon color="cyan" v-on:click="editPayment(row)" v-if="getPermission('payment:update')">
                  <v-icon size="20">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="red" v-on:click="deletePayment(row)" v-if="getPermission('payment:delete')">
                  <v-icon size="20">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="9">
                <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no payment at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </ListingTable>
    <ListingFooter
      :dataLoading="paymentLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
    ></ListingFooter>
    <EditPaymentTemplate
      v-if="editPaymentDialog"
      :detail="localDetail"
      :payment-id="selectedPaymentId"
      :payment-dialog="editPaymentDialog"
      v-on:close="editPaymentDialog = false; selectedPaymentId = null;"
      v-on:success="onPaymentUpdated()"
    ></EditPaymentTemplate>
    <DeleteDialog :delete-dialog="deletePaymentDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3
          class="font-weight-500 delete-text"
          style="font-size: 18px !important"
        >
          Are you sure you want to delete
          <span class="font-weight-650">{{ selectedDeletePayment?.barcode }}</span>
          ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deletePaymentLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deletePaymentDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deletePaymentLoading"
          :loading="deletePaymentLoading"
          color="red lighten-1 white--text"
          v-on:click="deletePaymentConfirm()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>

  </div>
</template>

<script>
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import DeleteDialog from "@/view/pages/partials/Delete";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import EditPaymentTemplate from "@/view/pages/invoice/Edit-Payment.vue";
import { QUERY, DELETE } from "@/core/services/store/request.module";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin, ValidationMixin],
  props: {
    type: {
      type: String,
      default: null,
    },
    typeId: {
      type: Number,
      default: 0,
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      paymentLoading: false,
      rowData: [],
      currentPage: 1,
      status: "all",
      search: null,
      totalPages: 0,
      totalRows: 0,
      rowsOffset: 0,
      selectedPaymentId: null,
      editPaymentDialog: false,
      deletePaymentDialog: false,
      deletePaymentLoading: false,
      selectedDeletePayment: null,
      localDetail: { ...this.detail },
    };
  },
  watch: {
    typeId() {
      this.$nextTick(() => {
        this.getPayments();
      });
    },
     detail: {
    deep: true,
    immediate: true,
    handler(val) {
      this.localDetail = { ...val }; 
    }
  }
  },
  methods: {
    clearFilter() {
      this.search = null;
      this.getPayments();
    },

    getPayments() {
      if (this.paymentLoading) return false;
      this.paymentLoading = true;
      const data = {
        current_page: this.currentPage,
        entity: 0,
        search: this.search,
        status: this.status,
        type: this.type,
        type_id: this.typeId,
      };
      this.$store
        .dispatch(QUERY, { url: "payment", data })
        .then(({ data }) => {
          this.totalPages = Math.ceil(data.total_rows / data.per_page);
          this.currentPage = data.current_page;
          this.rowData = data.rows;
          this.totalRows = data.total_rows;
          this.rowsOffset = data.offset;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.paymentLoading = false;
        });
    },
    editPayment(row) {
      this.selectedPaymentId = row.id;
      this.editPaymentDialog = true;
    },

    onPaymentUpdated() {
      this.getPayments();
      this.$emit("payment-updated");
    },

    deletePayment(row) {
      this.selectedDeletePayment = row;
      this.deletePaymentDialog = true;
    },

    deletePaymentConfirm() {
      this.deletePaymentLoading = true;
      this.$store
        .dispatch(DELETE, {
          url: `payment/${this.selectedDeletePayment.id}`,
        })
        .then(() => {
          this.deletePaymentDialog = false;
          this.selectedDeletePayment = null;
          this.getPayments();
          this.$emit("payment-updated");
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deletePaymentLoading = false;
        });
    },

    routeToInvoice(row) {
      this.$nextTick(() => {
        this.$router.push(
          this.getDefaultRoute("payment.detail", {
            params: { id: row.id },
          })
        );
      });
    },
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.rowData) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.rowData ? this.rowData.length : 0);
    },
   isAdmin() {
    const user = this.$store?.state?.auth?.user;
    if (!user) return false;
      return user.role == 1 || user.role == 6 || user.role == 7;
    },
  },
  mounted() {
    this.getPayments();
  },
  components: {
    Barcode,
    TableActivity,
    ListingFooter,
    ListingTable,
    DeleteDialog,
    EditPaymentTemplate,
  },
};
</script>